import { render, staticRenderFns } from "./GroupGeneralCharts.vue?vue&type=template&id=fdfe56d2&scoped=true&"
import script from "./GroupGeneralCharts.vue?vue&type=script&lang=js&"
export * from "./GroupGeneralCharts.vue?vue&type=script&lang=js&"
import style0 from "./GroupGeneralCharts.vue?vue&type=style&index=0&id=fdfe56d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe56d2",
  null
  
)

export default component.exports